// extracted by mini-css-extract-plugin
export var footer = "_qs-0";
export var inherit = "_qs-1";
export var input = "_qs-2";
export var modalContent = "_qs-3";
export var quillEditor = "_qs-4";
export var subtitle = "_qs-5";